import React from 'react'
import {
    Box,
    Text,
    Button,
    Link
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { FormattedMessage } from 'react-intl'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/* Styles */
import { useStoreLocatorStyles } from '../styles/storeLocatorStyles'

/* Hooks */
import { useStoreLocator } from '../../../contexts/store-locator-context';

const StoreLocatorNoResults = () => {
    const {app: appConfig} = getConfig()
    /* Styling */
    const styles = useStoreLocatorStyles()
    const noResultsStyling = styles?.components?.noResults

    const {
        noSearchResults
    } = useStoreLocator()

    return (
        <>
            {noSearchResults &&
                <Box {...noResultsStyling.container}>
                    <Text {...noResultsStyling.title}>
                        <FormattedMessage
                            defaultMessage='No result found'
                            id='store_locator.noResults.title'
                        />
                    </Text>
                    <Text {...noResultsStyling.subTitle}>
                        <FormattedMessage
                            defaultMessage='We could not find store you are looking for. Please contact our Customer Service.'
                            id='store_locator.noResults.sub_title'
                        />
                    </Text>
                    <Button as={Link}
                        variant='outline'
                        href={appConfig?.CUSTOMER_SERVICE_URL}
                        target='_blank'
                        rel="noopener noreferrer"
                        {...noResultsStyling.cta}>
                        <FormattedMessage
                            defaultMessage='Help'
                            id='store_locator.noResults.help_cta'
                        />
                    </Button>
                </Box>
            }
        </>
    )
}

export default StoreLocatorNoResults
